// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"292":"8f8cb98b","418":"d85ce4ce"}[chunkId] + ".chunk.css";
};